import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide11 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={10}
      total={total}
      label="Partner Model"
      kicker={t.kicker}
      onActive={onActive}
      bgStyle={{
        "--slide-bg": "radial-gradient(700px 480px at 75% 35%,rgba(216,182,46,.25),transparent 68%),linear-gradient(110deg,#020202,#07120e,#020202)"
      }}
    >

      <h2>{t.title}</h2>
      
      <div className="grid three wide">
        <div className="card">
          <span className="num">SELL</span>
          <h3>{t.c1Title}</h3>
          <p>{t.c1Body}</p>
        </div>
        <div className="card">
          <span className="num">BUILD</span>
          <h3>{t.c2Title}</h3>
          <p>{t.c2Body}</p>
        </div>
        <div className="card">
          <span className="num">RUN</span>
          <h3>{t.c3Title}</h3>
          <p>{t.c3Body}</p>
        </div>
      </div>

      <table className="matrix">
        <thead>
          <tr>
            <th>{t.tableH1}</th>
            <th>{t.tableH2}</th>
            <th>{t.tableH3}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t.r1C1}</td>
            <td>{t.r1C2}</td>
            <td><span className="coverage">{t.covered}</span></td>
          </tr>
          <tr>
            <td>{t.r2C1}</td>
            <td>{t.r2C2}</td>
            <td><span className="coverage">{t.covered}</span></td>
          </tr>
        </tbody>
      </table>
    </SlideShell>
  );
};





